import { render, staticRenderFns } from "./PurchaseListItem.vue?vue&type=template&id=6d50a9a1&"
import script from "./PurchaseListItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseListItem.vue"
export default component.exports